var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreationIcon = function SvgCreationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512.02"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M255.99 0c70.64 0 134.64 28.67 180.97 74.99C483.33 121.37 512 185.37 512 256.01s-28.67 134.64-74.98 180.97c-46.39 46.37-110.39 75.04-181.03 75.04-70.69 0-134.7-28.67-181.01-74.98l-.84-.91C28.32 389.87 0 326.23 0 256.01c0-70.64 28.67-134.64 74.98-180.96C121.29 28.67 185.3 0 255.99 0m-1.21 188.07c16.01-16.68 27.21-31.11 51.87-33.93 46.29-5.31 88.88 42.08 65.5 88.74-6.66 13.28-20.2 29.09-35.19 44.59-16.44 17.03-34.64 33.71-47.39 46.35l-34.77 34.5-28.72-27.65c-34.57-33.3-90.94-75.2-92.8-127.1-1.3-36.36 27.39-59.66 60.4-59.24 29.49.39 41.9 15.07 61.1 33.74m160.37-91.21c-40.7-40.69-96.99-65.88-159.16-65.88-62.14 0-118.41 25.2-159.11 65.9-40.72 40.68-65.9 96.96-65.9 159.13 0 61.79 24.89 117.77 65.14 158.42l.76.71c40.7 40.7 96.97 65.9 159.11 65.9 62.17 0 118.46-25.19 159.16-65.88 40.68-40.7 65.87-96.98 65.87-159.15s-25.19-118.45-65.87-159.15"
  })));
};
export default SvgCreationIcon;